/* ===============================================================
   FREE SABER  -  engine for snippets/rotating-offer.liquid
   ---------------------------------------------------------------
   Free-saber giveaway. Runs INSTEAD of the Unified Offer (BOGO);
   only one is loaded per page (see layout/theme.liquid).

   PICKING - the shopper CHOOSES their gift from a horizontally
   scrollable rail of the qualifying tier's pool, sorted most-valuable
   first. The offer only arms when exactly freeCount sabers are
   selected.

   ===============================================================
   PROCEED-BUTTON: PERFORMANCE, AND THE THREE THINGS THAT BROKE
   ---------------------------------------------------------------
   Click-to-drawer was ~7.7s. Measured causes, and what replaced them:

   1. SIX sequential GET /cart.js before the add (~570ms). One read now
      does all three jobs - see prepareCart().

   2. ~5.3s waiting on an event that had ALREADY FIRED. Discount Ninja
      watches fetch cart mutations, so it reacted to our /cart/add.js
      and fired `la:dn:cart:updated` at t=2349ms - while the old code
      only subscribed at t=2390ms, 41ms too late. Having missed it, it
      sat out a 3000ms fallback, a 400ms poll loop and a 2500ms nudge.
      FIX: armDNWatcher() subscribes BEFORE the first cart write and
      LATCHES the event.

   3. TRIGGER DN BEFORE THE ADD, NOT AFTER.  <- order matters
      Adding first and triggering after made DN wipe the whole cart and
      rebuild it. Measured, same cart both ways:
        add -> trigger :  POST /cart/clear.js @714, POST /cart/add.js @1217
        trigger -> add :  (no DN cart calls at all)
      The trigger must still come AFTER prepareCart(), which is where a
      stale __limoniappsdiscountninja attribute gets wiped.

   ---------------------------------------------------------------
   BUG 1: THE FROZEN PAGE (fixed - keep the guard)

   An early version opened the drawer first and repaired afterwards. The
   repair re-rendered #shopify-section-cart-drawer while the drawer was
   OPEN, swapping <cart-drawer> for a fresh, CLOSED one:

     t=3130  drawer section replaced -> drawer opens
     t=3628  drawerOpen=true,  body.overflow-hidden added
     t=4368  drawer section replaced AGAIN (repair)
     t=4652  drawerOpen=false, body.overflow-hidden STILL SET

   base.css locks the page with body.overflow-hidden while a drawer is
   open, so the lock outlived the element that would have removed it and
   the shopper was stranded on a frozen page.
   => applyCartSections() now REFUSES to re-render an open drawer.

   ---------------------------------------------------------------
   BUG 2: "YOUR CART IS EMPTY" WHILE THE ICON SAYS 2 (fixed)

   The drawer markup is a point-in-time SNAPSHOT. Two things combined:
     - the snapshot was fetched in parallel with the verify read, so it
       could be taken during a window where the cart was momentarily
       empty (DN clearing before it rebuilds);
     - the icon bubble is re-rendered later by the theme/DN on
       cart:updated, but the drawer is not, because of the Bug 1 guard.
   The bubble corrected itself to "2 items" and the drawer stayed stuck
   on the empty snapshot.

   => verify and fetch are SEQUENTIAL again (closes the window), and
      fetchCartSectionsSettled() refuses to open on a snapshot whose
      markup says is-empty when we just added items.

   Invariants - keep these if you edit:
   - Subscribe to DN events BEFORE mutating the cart, never after.
   - Trigger the DN promotion BEFORE the add, but AFTER prepareCart().
   - NEVER re-render the cart-drawer section while the drawer is open.
   - NEVER open on a drawer snapshot that disagrees with the real cart.
   - Any path that can drop the drawer must releaseScrollLock().

   NOTE: assets/unified-offer.js (the BOGO path) still has the ORIGINAL
   slow sequence. If that offer is switched back on, port these across.

   A/B NOTE: this file is kept BYTE-IDENTICAL with the copy in the
   FASTER OFFER theme, so the two themes differ only in the
   what's-the-difference explainer being tested. If you edit one, edit
   both, or the test is measuring two things at once.
   =============================================================== */
(function () {
  'use strict';

  var cfgEl = document.getElementById('rotating-offer-data');
  if (!cfgEl) return;                 // not in rotating mode -> no-op
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  CFG.pools = CFG.pools || { t1: [], t2: [], t3: [] };

  /* -- tunables ------------------------------------------------- */
  var DN_WAIT_MS = 1200;      // cap, not a delay - usually resolves in 200-400ms
  var DN_NUDGE_MS = 900;
  var SNAPSHOT_RETRY_MS = 350; // backoff when the drawer markup looks stale
  var SNAPSHOT_TRIES = 2;

  /* -- state ---------------------------------------------------- */
  var selected = false;
  var optedOut = false;
  var busy = false;
  var currentTier = 0;
  var currentFreebies = null;
  var currentTotalUsd = 0;
  var cartSubtotalUsd = 0;
  var cartVariantIds = [];
  var chosenByTier = {};
  var pickerTier = 0;
  var dayStamp = 0;

  /* === UTILITIES ============================================== */

  function fmt(amount) {
    try {
      return new Intl.NumberFormat(Shopify.locale || 'en', {
        style: 'currency', currency: Shopify.currency.active
      }).format(amount);
    } catch (e) { return (CFG.cur || '$') + amount.toFixed(2); }
  }

  function zeroLabel() { return (CFG.cur || '$') + '0'; }

  function parseNum(txt) {
    if (!txt) return null;
    var s = txt.replace(/[^\d.,]/g, '').trim();
    if (!s) return null;
    if (s.indexOf('.') > -1 && s.indexOf(',') > -1) {
      if (s.lastIndexOf('.') < s.lastIndexOf(',')) s = s.replace(/\./g, '').replace(',', '.');
      else s = s.replace(/,/g, '');
    } else if (s.indexOf(',') > -1) { s = s.replace(',', '.'); }
    var n = parseFloat(s);
    return isNaN(n) ? null : n;
  }

  function getRate() { return parseFloat(Shopify.currency.rate) || 1; }
  function localToUsd(local) { return local / getRate(); }

  function getSelectedVariantPrice() {
    var checked = document.querySelector('input[type="radio"]:checked');
    if (checked && checked.id) {
      var label = document.querySelector('label[for="' + checked.id + '"]');
      if (label) {
        var priceEl = label.querySelector('.quantity-break__price span');
        if (priceEl) { var p = parseNum(priceEl.textContent); if (p) return { local: p, usd: localToUsd(p) }; }
      }
    }
    if (checked) {
      var parentLabel = checked.closest('label.quantity-break');
      if (parentLabel) {
        var pe = parentLabel.querySelector('.quantity-break__price span');
        if (pe) { var p2 = parseNum(pe.textContent); if (p2) return { local: p2, usd: localToUsd(p2) }; }
      }
    }
    var activeQb = document.querySelector('.quantity-break--active .quantity-break__price span')
      || document.querySelector('.quantity-break.active .quantity-break__price span');
    if (activeQb) { var p3 = parseNum(activeQb.textContent); if (p3) return { local: p3, usd: localToUsd(p3) }; }
    var mainPrice = document.querySelector('.price-item--regular');
    if (mainPrice) { var p4 = parseNum(mainPrice.textContent); if (p4) return { local: p4, usd: localToUsd(p4) }; }
    return null;
  }

  function resolveTier(totalUsd) {
    var bands = [
      { tier: 3, min: CFG.thresholds.t3 },
      { tier: 2, min: CFG.thresholds.t2 },
      { tier: 1, min: CFG.thresholds.t1 }
    ];
    for (var i = 0; i < bands.length; i++) {
      if (totalUsd >= bands[i].min) {
        var fb = chosenForTier(bands[i].tier);
        if (fb) return { tier: bands[i].tier, freebies: fb };
      }
    }
    return { tier: 0, freebies: null };
  }

  // fetch() - NOT XMLHttpRequest: Discount Ninja only detects cart mutations
  // made via fetch, so XHR adds/updates are invisible to it.
  function xhrGet(url) {
    return fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) {
      if (r.ok) return r.json();
      throw new Error(r.status);
    }, function () { throw new Error('xhr'); });
  }

  function xhrPost(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) {
      if (r.ok) return r.json();
      if (r.status === 422) {
        return r.json().then(function (resp) {
          throw new Error(resp.description || 'This variant is currently unavailable.');
        }, function () { throw new Error('This variant is currently unavailable.'); });
      }
      throw new Error('network');
    }, function () { throw new Error('network'); });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cleanName(s) {
    var raw = String(s == null ? '' : s);
    var out = raw
      .replace(/\(\s*free\s*\)/ig, '')
      .replace(/\s*\|\s*$/, '')
      .replace(/\s*\|\s*/g, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim();
    return out || raw;
  }

  function freebieValueCents(freebies) {
    return (freebies || []).reduce(function (s, f) { return s + (f.price || 0); }, 0);
  }

  function delay(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* === PACIFIC DAY INDEX (DST-safe via civil-date math) ======== */

  function pacificParts(date) {
    var p = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric', month: '2-digit', day: '2-digit', hour12: false
    }).formatToParts(date);
    var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
    return o;
  }

  function civilDayNumber(y, m, d) { return Math.floor(Date.UTC(y, m - 1, d) / 86400000); }

  function parseAnchor(str) {
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})/.exec(str || '');
    if (!m) return { y: 2026, m: 1, d: 1 };
    return { y: +m[1], m: +m[2], d: +m[3] };
  }

  function dayIndex() {
    var t = pacificParts(new Date());
    var a = parseAnchor(CFG.cycle && CFG.cycle.anchor);
    return civilDayNumber(+t.year, +t.month, +t.day) - civilDayNumber(a.y, a.m, a.d);
  }

  /* === DETERMINISTIC DAILY PICK (the DEFAULT selection) ======== */

  function hash32(str) {
    var h = 2166136261 >>> 0;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }

  function mulberry32(a) {
    return function () {
      a |= 0; a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function shuffle(arr, seed) {
    var rng = mulberry32(seed);
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(rng() * (i + 1));
      var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }

  function sequencedPick(list, day, salt) {
    var N = list.length;
    if (N === 0) return null;
    var pass = Math.floor(day / N);
    var within = ((day % N) + N) % N;
    var seed = (hash32(salt) ^ Math.imul(pass, 0x9E3779B1)) >>> 0;
    return shuffle(list, seed)[within];
  }

  function buildPairs(pool) {
    var pairs = [];
    for (var i = 0; i < pool.length; i++)
      for (var j = i + 1; j < pool.length; j++) pairs.push([pool[i], pool[j]]);
    return pairs;
  }

  function pickSingle(pool, day, salt) {
    if (!pool || !pool.length) return null;
    return sequencedPick(pool, day, salt);
  }

  function pickPair(pool, day, salt) {
    if (!pool || pool.length < 2) return null;
    return sequencedPick(buildPairs(pool), day, salt);
  }

  function rotationForTier(tier) {
    var day = dayIndex();
    if (tier === 1) { var s = pickSingle(CFG.pools.t1, day, 'T1'); return s ? [s] : null; }
    if (tier === 2) { return pickPair(CFG.pools.t2, day, 'T2pairs'); }
    if (tier === 3) { return pickPair(CFG.pools.t3, day, 'T3pairs'); }
    return null;
  }

  /* === SHOPPER'S CHOICE ======================================= */

  function poolForTier(tier) { return (CFG.pools && CFG.pools['t' + tier]) || []; }
  function needForTier(tier) { return (CFG.freeCount && CFG.freeCount['t' + tier]) || 1; }

  function findInPool(pool, vid) {
    for (var i = 0; i < pool.length; i++) if (pool[i].variantId === vid) return pool[i];
    return null;
  }

  function chosenForTier(tier) {
    var pool = poolForTier(tier);
    var need = needForTier(tier);
    if (pool.length < need) return null;

    var saved = chosenByTier[tier];
    if (saved) {
      var mapped = [];
      for (var i = 0; i < saved.length; i++) {
        var hit = findInPool(pool, saved[i]);
        if (hit) mapped.push(hit);
      }
      return mapped;
    }

    var def = rotationForTier(tier) || pool.slice(0, need);
    chosenByTier[tier] = def.map(function (f) { return f.variantId; });
    return def;
  }

  function substituteFreebies(tier, current) {
    var pool = poolForTier(tier), need = needForTier(tier);
    var used = (current || []).map(function (f) { return f.variantId; });
    var out = [];
    for (var i = 0; i < pool.length && out.length < need; i++) {
      if (pool[i].available === false) continue;
      if (used.indexOf(pool[i].variantId) > -1) continue;
      out.push(pool[i]);
    }
    return out.length === need ? out : null;
  }

  /* === ERROR / LOADER ========================================= */

  function showError(msg) { var el = document.getElementById('unified-offer-error'); if (el) { el.textContent = msg; el.style.display = 'block'; } }
  function clearError() { var el = document.getElementById('unified-offer-error'); if (el) { el.textContent = ''; el.style.display = 'none'; } }
  function showLoader() {
    var l = document.getElementById('unified-offer-proceed-loader'), t = document.getElementById('unified-offer-proceed-text');
    if (l) l.classList.remove('hidden'); if (t) t.style.display = 'none';
  }
  function hideLoader() {
    var l = document.getElementById('unified-offer-proceed-loader'), t = document.getElementById('unified-offer-proceed-text');
    if (l) l.classList.add('hidden'); if (t) t.style.display = '';
  }

  /* === DISCOUNT NINJA ========================================= */

  function dnToken() { return (currentTier && CFG.dnTokens) ? (CFG.dnTokens['t' + currentTier] || '') : ''; }

  function triggerDNPromotion(token) {
    if (!token) return;
    if (typeof discountNinja !== 'undefined' && discountNinja.api && discountNinja.api.promotions) {
      try { discountNinja.api.promotions.trigger(token); } catch (e) { /* non-critical */ }
    }
  }

  // DN watches fetch cart mutations, so it can fire `la:dn:cart:updated` while
  // our own /cart/add.js promise chain is still resolving - i.e. BEFORE a
  // listener attached afterwards would exist. Arm this before the first cart
  // write: it latches the event, so settled() returns immediately for an update
  // that already landed.
  function armDNWatcher() {
    var fired = false;
    var waiters = [];
    function onEvt() {
      fired = true;
      var list = waiters.splice(0, waiters.length);
      for (var i = 0; i < list.length; i++) list[i]();
    }
    document.addEventListener('la:dn:cart:updated', onEvt);
    return {
      settled: function (capMs) {
        if (fired) return Promise.resolve();
        return new Promise(function (resolve) {
          var done = false;
          function fin() { if (done) return; done = true; clearTimeout(timer); resolve(); }
          waiters.push(fin);
          var timer = setTimeout(fin, capMs || DN_WAIT_MS);
        });
      },
      dispose: function () { document.removeEventListener('la:dn:cart:updated', onEvt); }
    };
  }

  // One cart read doing three jobs that used to cost three round trips:
  // re-tier against reality, clear stale freebie/DN state, and decide whether
  // the main variant still needs adding.
  function prepareCart(vid) {
    return xhrGet('/cart.js').then(function (cart) {
      var cents = 0; cartVariantIds = [];
      cart.items.forEach(function (it) {
        if (it.properties && it.properties._free_saber) return;
        cents += it.final_line_price;
        cartVariantIds.push(it.variant_id);
      });
      cartSubtotalUsd = localToUsd(cents / 100);
      markUpsellsInCart();
      update();

      if (!currentTier || !currentFreebies) {
        return { ok: false, message: 'This offer is not available for your current cart.' };
      }
      var need = needForTier(currentTier);
      if (currentFreebies.length !== need) {
        return { ok: false, message: need > 1
          ? 'Please choose your ' + need + ' free sabers.'
          : 'Please choose your free saber.' };
      }

      var updates = {}, hasChanges = false;
      cart.items.forEach(function (it) {
        if (it.properties && it.properties._free_saber) { updates[it.key] = 0; hasChanges = true; }
      });
      var hasDN = cart.attributes && cart.attributes.__limoniappsdiscountninja
        && cart.attributes.__limoniappsdiscountninja !== '';

      var clearing = Promise.resolve();
      if (hasChanges || hasDN) {
        var payload = { updates: updates };
        if (hasDN) payload.attributes = { __limoniappsdiscountninja: '' };
        clearing = xhrPost('/cart/update.js', payload).catch(function () {});
      }
      if (typeof discountNinja !== 'undefined' && discountNinja.api && discountNinja.api.cache) {
        try { discountNinja.api.cache.clear(); } catch (e) { /* non-critical */ }
      }

      var alreadyHasMain = cart.items.some(function (it) {
        return it.variant_id === vid && !(it.properties && it.properties._free_saber);
      });

      return clearing.then(function () { return { ok: true, alreadyHasMain: alreadyHasMain }; });
    });
  }

  function nudgeDN(watcher) {
    return xhrPost('/cart/update.js', { updates: {} })
      .then(function () { return watcher ? watcher.settled(DN_NUDGE_MS) : null; })
      .catch(function () { /* non-critical */ });
  }

  // Verify the settled cart and repair once if DN dropped or skipped a gift
  // line. No-ops on the happy path. Runs BEFORE the markup is fetched.
  function ensureFreebiesApplied(freebies, tier, watcher, attempt) {
    attempt = attempt || 0;
    return xhrGet('/cart.js').then(function (cart) {
      var missing = freebies.filter(function (f) {
        return !cart.items.some(function (it) {
          return it.variant_id === f.variantId && it.properties && it.properties._free_saber;
        });
      });
      var hasDN = cart.attributes && cart.attributes.__limoniappsdiscountninja
        && cart.attributes.__limoniappsdiscountninja !== '';
      var zeroed = freebies.every(function (f) {
        return cart.items.some(function (it) { return it.variant_id === f.variantId && it.final_line_price === 0; });
      });
      if (!missing.length && (zeroed || hasDN)) return false;
      if (attempt >= 1) return false;

      var fix = missing.length
        ? xhrPost('/cart/add.js', { items: missing.map(function (f) {
            return { id: f.variantId, quantity: 1, properties: { _free_saber: 't' + tier } };
          }) }).catch(function () {})
        : Promise.resolve();

      return Promise.resolve(fix)
        .then(function () { return nudgeDN(watcher); })
        .then(function () { return ensureFreebiesApplied(freebies, tier, watcher, attempt + 1); })
        .then(function () { return true; });
    }).catch(function () { return false; });
  }

  /* === CART DRAWER ============================================
     Read the header notes on Bug 1 and Bug 2 before editing.        */

  function drawerIsOpen() {
    var d = document.querySelector('cart-drawer');
    return !!(d && (d.classList.contains('active') || d.classList.contains('animate') || d.hasAttribute('open')));
  }

  // base.css locks the page with body.overflow-hidden while a drawer is open.
  // If a drawer ever disappears without closing itself, that class is what
  // strands the shopper on a page that will not scroll.
  function releaseScrollLock() {
    if (drawerIsOpen()) return;
    document.body.classList.remove('overflow-hidden');
  }

  function fetchCartSections() {
    var u = new URL(window.location.href.split('#')[0]);
    u.searchParams.set('sections', 'cart-icon-bubble,cart-drawer');
    u.searchParams.set('sections_url', window.location.pathname);
    return fetch(u.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  // BUG 2 GUARD. The markup is a point-in-time snapshot, and DN can clear the
  // cart before rebuilding it. A snapshot taken inside that window renders an
  // EMPTY drawer, and because we refuse to re-render an open drawer (Bug 1) it
  // stays empty while the icon bubble corrects itself to "2 items". If the
  // markup says is-empty when we know we just added lines, take another.
  function fetchCartSectionsSettled(tries) {
    tries = tries || 0;
    return fetchCartSections().then(function (map) {
      var dr = map && map['cart-drawer'];
      if (!dr) return map;
      if (!/is-empty/.test(dr)) return map;           // markup has items - good
      if (tries >= SNAPSHOT_TRIES) return map;        // stop retrying; open what we have
      return delay(SNAPSHOT_RETRY_MS).then(function () {
        return fetchCartSectionsSettled(tries + 1);
      });
    });
  }

  // Swapping #shopify-section-cart-drawer replaces the <cart-drawer> element
  // itself, and the replacement comes back CLOSED. Doing that to an open drawer
  // slams it shut and orphans the scroll lock, so refuse it.
  function applyCartSections(map) {
    if (!map) return false;
    var skipDrawer = drawerIsOpen();
    ['cart-icon-bubble', 'cart-drawer'].forEach(function (handle) {
      if (handle === 'cart-drawer' && skipDrawer) return;
      if (!map[handle]) return;
      var mount = document.getElementById('shopify-section-' + handle) || document.getElementById(handle);
      if (!mount) return;
      var doc = new DOMParser().parseFromString(map[handle], 'text/html');
      var inner = doc.querySelector('#shopify-section-' + handle) || doc.querySelector('.shopify-section') || doc.body;
      mount.innerHTML = inner.innerHTML;
    });
    return true;
  }

  // DN prepares the discounted checkout when the visitor clicks a checkout
  // button it controls - the drawer's name="checkout" button is one. So the
  // offer finishes in the drawer, not with a redirect.
  function openCartDrawer(map) {
    applyCartSections(map);
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) { releaseScrollLock(); window.location.href = '/cart'; return; }
    if (typeof drawer.open === 'function') drawer.open();
    else drawer.classList.add('animate', 'active');
    document.dispatchEvent(new CustomEvent('la:dn:drawercart:opened'));
  }

  // Add main product (if not already in cart) + the chosen free saber(s).
  // No cart read here - prepareCart() already told us what is in it.
  function addToCart(mainVid, alreadyHasMain, tier, freebies, triesLeft) {
    if (!freebies || !freebies.length) return Promise.reject(new Error('Please choose your free saber.'));
    var items = [];
    if (!alreadyHasMain) items.push({ id: mainVid, quantity: 1 });
    freebies.forEach(function (f) {
      items.push({ id: f.variantId, quantity: 1, properties: { _free_saber: 't' + tier } });
    });
    return xhrPost('/cart/add.js', { items: items })
      .then(function () { return freebies; })
      .catch(function (err) {
        if (triesLeft > 0) {
          var alt = substituteFreebies(tier, freebies);
          if (alt) return addToCart(mainVid, alreadyHasMain, tier, alt, triesLeft - 1);
        }
        throw err;
      });
  }

  /* === CHECKOUT FLOW ========================================== */

  function resolveMainVariantId() {
    var v = null;
    var stickySelect = document.querySelector('.sticky-atc__variant-select option:checked');
    if (stickySelect) v = stickySelect.getAttribute('data-variant-id');
    if (!v) { var vi = document.querySelector('product-form input[name="id"]'); if (vi) v = vi.value; }
    if (!v) { var cr = document.querySelector('.product-form__input input[type="radio"]:checked'); if (cr) v = cr.value; }
    return v;
  }

  function proceed() {
    if (!selected || busy) return;
    var btn = document.getElementById('unified-offer-proceed');

    var variantId = resolveMainVariantId();
    if (!variantId) { showError('Please select a variant.'); return; }
    var vid = parseInt(variantId, 10);

    busy = true;
    if (btn) btn.disabled = true;
    showLoader(); clearError();

    var watcher = armDNWatcher();   // armed BEFORE the first cart write
    var addedFreebies = null;
    var tierAtAdd = 0;

    prepareCart(vid)
      .then(function (plan) {
        if (!plan.ok) throw new Error(plan.message);
        tierAtAdd = currentTier;
        // Arm the promotion BEFORE the cart write (but after prepareCart wiped
        // any stale DN attribute). Triggering after the add makes DN clear the
        // whole cart and rebuild it - see the header note.
        triggerDNPromotion(dnToken());
        return addToCart(vid, plan.alreadyHasMain, currentTier, currentFreebies, 2);
      })
      .then(function (freebies) {
        addedFreebies = freebies;
        chosenByTier[tierAtAdd] = freebies.map(function (f) { return f.variantId; });
        currentFreebies = freebies;
        renderCard(); syncPickerState();
        return watcher.settled(DN_WAIT_MS);
      })
      // SEQUENTIAL on purpose. Fetching the markup in parallel with this verify
      // is what let an empty-cart snapshot through (Bug 2).
      .then(function () { return ensureFreebiesApplied(addedFreebies, tierAtAdd, watcher); })
      .then(function () { return fetchCartSectionsSettled(); })
      .then(function (sections) { openCartDrawer(sections); })
      .catch(function (err) {
        releaseScrollLock();
        showError(err && err.message === 'network'
          ? 'Something went wrong. Please check your connection and try again.'
          : (err && err.message) || 'Something went wrong. Please try again.');
      })
      .finally(function () {
        watcher.dispose();
        hideLoader();
        if (btn) btn.disabled = false;
        busy = false;
      });
  }

  /* === UI ===================================================== */

  function updateBuyButtons() {
    var atc = document.querySelector('.atc-button');
    var proceedBtn = document.getElementById('unified-offer-proceed');
    if (!proceedBtn) return;
    if (selected && currentTier && currentFreebies) {
      if (atc) atc.style.display = 'none';
      proceedBtn.style.display = 'block';
    } else {
      if (atc) atc.style.display = '';
      proceedBtn.style.display = 'none';
    }
  }

  function renderCard() {
    if (!currentFreebies) return;
    var imagesEl = document.getElementById('rsaber-images');
    var namesEl = document.getElementById('rsaber-names');
    var badgeEl = document.getElementById('rsaber-badge');
    var wasEl = document.getElementById('rsaber-was');

    var need = needForTier(currentTier);
    var n = currentFreebies.length;

    if (imagesEl) {
      var parts = currentFreebies.map(function (f) {
        return f.img
          ? '<div class="rw__img"><img src="' + f.img + '" alt="' + escapeHtml(cleanName(f.name)) + '" loading="lazy"></div>'
          : '<div class="rw__img"></div>';
      });
      for (var i = n; i < need; i++) parts.push('<div class="rw__img rw__img--empty"></div>');
      imagesEl.innerHTML = parts.join('');
    }

    if (namesEl) {
      namesEl.textContent = n
        ? currentFreebies.map(function (f) { return cleanName(f.name); }).join(' + ')
        : (need > 1 ? 'Pick ' + need + ' free sabers' : 'Pick your free saber');
    }
    if (badgeEl) badgeEl.textContent = (CFG.labels && CFG.labels['t' + currentTier]) || 'FREE SABER';
    if (wasEl) wasEl.textContent = '';

    renderSavings(freebieValueCents(currentFreebies), n);
  }

  function renderSavings(cents, n) {
    var amtEl = document.getElementById('rsaber-save-amt');
    var subEl = document.getElementById('rsaber-save-sub');

    if (amtEl) {
      var empty = !n;
      var txt = empty ? '—' : fmt((cents || 0) / 100);
      amtEl.classList.toggle('is-empty', empty);
      if (amtEl.textContent !== txt) {
        amtEl.textContent = txt;
        amtEl.classList.remove('is-pop');
        void amtEl.offsetWidth;
        amtEl.classList.add('is-pop');
      }
    }
    if (subEl) {
      var need = needForTier(currentTier);
      subEl.textContent = n
        ? ('on ' + n + ' free saber' + (n > 1 ? 's' : ''))
        : ('pick ' + need + ' to see your saving');
    }

    var cardRoot = document.getElementById('rotating-offer');
    if (cardRoot) cardRoot.classList.toggle('is-off', !selected);
  }

  /* === FREE-SABER CHOOSER (scrollable rail) =================== */

  function renderPicker() {
    var wrap = document.getElementById('rsaber-picker');
    var rail = document.getElementById('rsaber-pick-rail');
    var lab = document.getElementById('rsaber-pick-label');
    if (!wrap || !rail) return;

    if (!currentTier || !currentFreebies) { wrap.style.display = 'none'; pickerTier = 0; return; }
    wrap.style.display = '';

    var need = needForTier(currentTier);

    if (pickerTier !== currentTier) {
      var pool = poolForTier(currentTier).slice().sort(function (a, b) {
        return (b.price || 0) - (a.price || 0);
      });
      rail.innerHTML = pool.map(function (f) {
        var oos = f.available === false;
        var nm = escapeHtml(cleanName(f.name));
        var price = f.price > 0
          ? '<span class="rw__pick-price"><s>' + escapeHtml(fmt(f.price / 100)) + '</s><i>' + escapeHtml(zeroLabel()) + '</i></span>'
          : '';
        return '<button type="button" class="rw__pick-item" data-vid="' + f.variantId + '"' +
          (oos ? ' disabled aria-disabled="true"' : '') + ' aria-pressed="false" title="' + nm + '">' +
          '<span class="rw__pick-thumb">' +
            (f.img ? '<img src="' + f.img + '" alt="' + nm + '" loading="lazy">' : '') +
          '</span>' +
          '<span class="rw__pick-nm">' + (oos ? 'Sold out' : nm) + '</span>' +
          price +
          '<span class="rw__pick-tick" aria-hidden="true"><span>&#10003;</span></span>' +
        '</button>';
      }).join('');
      rail.setAttribute('aria-label', need > 1 ? ('Choose your ' + need + ' free sabers') : 'Choose your free saber');
      pickerTier = currentTier;
    }

    if (lab) {
      var chosenN = currentFreebies.length;
      if (chosenN >= need) {
        lab.textContent = need > 1 ? ('Choose your ' + need + ' free sabers') : 'Choose your free saber';
      } else {
        var left = need - chosenN;
        lab.textContent = 'Choose ' + left + ' more free saber' + (left > 1 ? 's' : '');
      }
    }
    syncPickerState();
  }

  function syncPickerState() {
    var rail = document.getElementById('rsaber-pick-rail');
    var cnt = document.getElementById('rsaber-pick-count');
    if (!rail) return;
    var ids = (currentFreebies || []).map(function (f) { return f.variantId; });
    var items = rail.querySelectorAll('.rw__pick-item');
    for (var i = 0; i < items.length; i++) {
      var on = ids.indexOf(parseInt(items[i].getAttribute('data-vid'), 10)) > -1;
      items[i].classList.toggle('is-on', on);
      items[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    if (cnt) {
      var need = needForTier(currentTier || 1);
      cnt.textContent = ids.length + '/' + need;
      cnt.classList.toggle('is-short', ids.length < need);
    }
  }

  function togglePick(vid) {
    if (!currentTier || !vid) return;
    var need = needForTier(currentTier);
    var arr = (chosenByTier[currentTier] || []).slice();
    var at = arr.indexOf(vid);

    if (at > -1) {
      arr.splice(at, 1);
    } else {
      arr.push(vid);
      while (arr.length > need) arr.shift();
    }
    chosenByTier[currentTier] = arr;

    clearError();
    currentFreebies = chosenForTier(currentTier);
    if (currentFreebies.length === need) { optedOut = false; selected = true; }
    else { selected = false; }

    renderCard();
    renderPicker();
    renderSummary();
    updateBuyButtons();
  }

  function renderLadder() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('.rw__node'));
    var labels = document.querySelectorAll('.rw__labels > div');
    function thr(el) { return CFG.thresholds['t' + el.getAttribute('data-tier')]; }
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.toggle('on', currentTotalUsd >= thr(nodes[i]));
    for (var j = 0; j < labels.length; j++) labels[j].classList.toggle('on', currentTotalUsd >= thr(labels[j]));

    var fill = document.getElementById('rw-track-fill');
    if (!fill || !nodes.length) return;
    var N = nodes.length, T = currentTotalUsd, ths = nodes.map(thr), pct = 0;
    if (N === 1) {
      pct = T >= ths[0] ? 100 : 0;
    } else if (T >= ths[N - 1]) {
      pct = 100;
    } else if (T > ths[0]) {
      for (var k = 0; k < N - 1; k++) {
        if (T >= ths[k] && T < ths[k + 1]) {
          var p0 = k / (N - 1) * 100, p1 = (k + 1) / (N - 1) * 100;
          pct = p0 + (T - ths[k]) / (ths[k + 1] - ths[k]) * (p1 - p0);
          break;
        }
      }
    }
    fill.style.width = pct.toFixed(1) + '%';
  }

  /* === UPSELL BOX ============================================= */

  function addUpsell(btn) {
    if (btn.disabled) return;
    var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!vid) return;
    btn.disabled = true; btn.textContent = 'Adding…';
    xhrPost('/cart/add.js', { items: [{ id: vid, quantity: 1 }] })
      .then(function () { return refreshCartSubtotal(); })
      .catch(function () { btn.disabled = false; btn.textContent = '+ Add'; });
  }

  function markUpsellsInCart() {
    var btns = document.querySelectorAll('.rsaber-ups__add');
    for (var i = 0; i < btns.length; i++) {
      var vid = parseInt(btns[i].getAttribute('data-variant-id'), 10);
      var inCart = vid && cartVariantIds.indexOf(vid) > -1;
      btns[i].classList.toggle('is-added', !!inCart);
      btns[i].disabled = !!inCart;
      btns[i].textContent = inCart ? '✓ Added' : '+ Add';
    }
  }

  function renderUpsellNudge() {
    var bar = document.getElementById('rsaber-ups-nudge');
    var txt = document.getElementById('rsaber-nudge-text');
    if (!bar) return;
    var fc = CFG.freeCount || { t1: 1, t2: 2, t3: 2 };
    var bands = [
      { tier: 1, min: CFG.thresholds.t1, need: 1, count: fc.t1 },
      { tier: 2, min: CFG.thresholds.t2, need: 2, count: fc.t2 },
      { tier: 3, min: CFG.thresholds.t3, need: 2, count: fc.t3 }
    ];
    var next = null;
    for (var i = 0; i < bands.length; i++) {
      if (currentTotalUsd < bands[i].min) {
        var pool = CFG.pools['t' + bands[i].tier] || [];
        if (pool.length >= bands[i].need) { next = bands[i]; break; }
      }
    }
    var gap = next ? next.min - currentTotalUsd : 0;
    if (!next || gap <= 0) { bar.style.display = 'none'; return; }
    var n = next.count;
    if (txt) txt.innerHTML = "You're <strong>" + fmt(gap * getRate()) + "</strong> away from <strong>" + n + ' free saber' + (n > 1 ? 's' : '') + "</strong>";
    bar.style.display = '';
  }

  function renderSummary() {
    var t = document.getElementById('rw-sum-text');
    var c = document.querySelector('.rw__sum-check');
    var n = (currentFreebies || []).length;
    if (currentTier && n) {
      var cents = freebieValueCents(currentFreebies);
      var line = n + ' saber' + (n > 1 ? 's' : '') + ' free';
      if (cents > 0) line += ' · save ' + fmt(cents / 100);
      if (t) t.textContent = line;
      if (c) c.style.display = '';
    } else {
      if (t) t.textContent = currentTier ? 'Choose your free saber' : 'Free saber with your order';
      if (c) c.style.display = 'none';
    }
  }

  function refreshCartSubtotal() {
    return xhrGet('/cart.js').then(function (cart) {
      var cents = 0; cartVariantIds = [];
      cart.items.forEach(function (it) {
        if (it.properties && it.properties._free_saber) return;
        cents += it.final_line_price;
        cartVariantIds.push(it.variant_id);
      });
      cartSubtotalUsd = localToUsd(cents / 100);
      markUpsellsInCart();
      update();
    }).catch(function () { update(); });
  }

  function update() {
    var pd = getSelectedVariantPrice();
    var selUsd = pd ? pd.usd : 0;
    var selId = parseInt(resolveMainVariantId() || '0', 10);
    var selectedInCart = selId && cartVariantIds.indexOf(selId) > -1;
    currentTotalUsd = cartSubtotalUsd + (selectedInCart ? 0 : selUsd);

    var resolved = currentTotalUsd > 0 ? resolveTier(currentTotalUsd) : { tier: 0, freebies: null };
    currentTier = resolved.tier;
    currentFreebies = resolved.freebies;
    renderLadder();
    renderUpsellNudge();
    renderSummary();

    var root = document.getElementById('rotating-offer');
    if (!currentTier || !currentFreebies) {
      if (root) root.style.display = 'none';
      selected = false;
      renderPicker();
      updateBuyButtons();
      return;
    }

    if (currentFreebies.length !== needForTier(currentTier)) selected = false;
    else if (!optedOut) selected = true;

    if (root) root.style.display = '';
    renderCard();
    renderPicker();
    updateBuyButtons();
  }

  function onCardToggle() {
    if (!currentTier || !currentFreebies) return;
    if (currentFreebies.length !== needForTier(currentTier)) return;
    selected = !selected;
    optedOut = !selected;
    clearError();
    renderCard();
    updateBuyButtons();
  }

  /* === INIT =================================================== */

  function init() {
    selected = false; optedOut = false; busy = false;
    pickerTier = 0;
    dayStamp = dayIndex();

    var card = document.getElementById('rsaber-card');
    if (card && !card.__rwBound) {
      card.__rwBound = true;
      card.addEventListener('click', onCardToggle);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onCardToggle(); }
      });
    }
    var proceedBtn = document.getElementById('unified-offer-proceed');
    if (proceedBtn && !proceedBtn.__rwBound) { proceedBtn.__rwBound = true; proceedBtn.addEventListener('click', proceed); }

    var rail = document.getElementById('rsaber-pick-rail');
    if (rail && !rail.__rwWheelBound) {
      rail.__rwWheelBound = true;
      rail.addEventListener('wheel', function (e) {
        if (rail.scrollWidth <= rail.clientWidth) return;
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        var step = e.deltaMode === 1 ? e.deltaY * 16 : e.deltaY;
        var before = rail.scrollLeft;
        rail.scrollLeft += step;
        if (rail.scrollLeft !== before) e.preventDefault();
      }, { passive: false });
    }

    var head = document.getElementById('rw-head');
    if (head && !head.__rwBound) {
      head.__rwBound = true;
      var togglePanel = function () {
        var panel = head.closest('.rw');
        if (!panel) return;
        var collapsed = panel.classList.toggle('rw--collapsed');
        head.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      };
      head.addEventListener('click', togglePanel);
      head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); togglePanel(); }
      });
    }

    if (!document.__rwDocBound) {
      document.__rwDocBound = true;

      document.addEventListener('change', function (e) {
        if (busy) return;
        if (e.target.matches('input[type="radio"], select')) {
          clearError();
          refreshCartSubtotal();
          [300, 600, 1000].forEach(function (d) { setTimeout(function () { if (!busy) update(); }, d); });
        }
      });

      // Our own writes during proceed() also fire cart:updated. Re-reading the
      // cart mid-flow was several of the redundant round trips in the old
      // timing - ignore it while the offer is committing.
      document.addEventListener('cart:updated', function () { if (!busy) refreshCartSubtotal(); });

      document.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var pickBtn = t.closest('.rw__pick-item');
        if (pickBtn) {
          if (!pickBtn.disabled) togglePick(parseInt(pickBtn.getAttribute('data-vid'), 10));
          return;
        }
        var addBtn = t.closest('.rsaber-ups__add');
        if (addBtn) { addUpsell(addBtn); return; }
        if (t.closest('[name="add"], .product-form__submit, .atc-button, .quick-add__submit')) {
          setTimeout(function () { if (!busy) refreshCartSubtotal(); }, 700);
        }
      });

      setInterval(function () {
        var d = dayIndex();
        if (d === dayStamp) return;
        dayStamp = d;
        chosenByTier = {};
        pickerTier = 0;
        update();
      }, 60000);
    }

    refreshCartSubtotal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () { setTimeout(init, 200); });

})();
